import { render, staticRenderFns } from "./step-editor.vue?vue&type=template&id=4cec0641&scoped=true"
import script from "./step-editor.vue?vue&type=script&lang=js"
export * from "./step-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec0641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cec0641')) {
      api.createRecord('4cec0641', component.options)
    } else {
      api.reload('4cec0641', component.options)
    }
    module.hot.accept("./step-editor.vue?vue&type=template&id=4cec0641&scoped=true", function () {
      api.rerender('4cec0641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/step-editor.vue"
export default component.exports